/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        const LOG_CATEGORY = "WPT.Navigation.Detail";
        const STANDARD_LAYOUTS = [
            {
                Name: "CustomQuery",
                Class: "WPTNamespace.Navigation.DetailLayoutCustomQuery"
            },
            {
                Name: "DocumentList",
                Class: "WPTNamespace.Navigation.DetailLayoutDocumentList"
            },
            {
                Name: "DocumentRetrieval",
                Class: "WPTNamespace.Navigation.DetailLayoutDocumentRetrieval"
            },
            {
                Name: "DocumentView",
                Class: "WPTNamespace.Navigation.DetailLayoutDocumentView"
            },
            {
                Name: "Envelopes",
                Class: "WPTNamespace.Navigation.DetailLayoutEnvelopes"
            },
            {
                Name: "FlexView",
                Class: "WPTNamespace.Navigation.DetailLayoutFlexView"
            },
            {
                Name: "FormView",
                Class: "WPTNamespace.Navigation.DetailLayoutFormView"
            },
            {
                Name: "PersonalDocuments",
                Class: "WPTNamespace.Navigation.DetailLayoutPersonalDocuments"
            },
            {
                Name: "SavedSearches",
                Class: "WPTNamespace.Navigation.DetailLayoutSavedSearches"
            },
            {
                Name: "Upload",
                Class: "WPTNamespace.Navigation.DetailLayoutUpload"
            },
            {
                Name: "UserAdmin",
                Class: "WPTNamespace.Navigation.DetailLayoutUserAdmin"
            },
            {
                Name: "UserGroupAdmin",
                Class: "WPTNamespace.Navigation.DetailLayoutUserGroupAdmin"
            },
            {
                Name: "Workflow",
                Class: "WPTNamespace.Navigation.DetailLayoutWorkflow"
            }
        ];
        /*
        * I'm not entirely sure we need a class which extends the base class here.
        *
        * Note: we load custom layouts on demand one at a time. The callback structure of the script loading mechanism
        * means we can't actually do it as a batch.
        */
        class DetailNavigationHandler {
            constructor(core, navigation) {
                this._log = null;
                this.DetailView = null;
                // One list of all layouts probably the most useful, but maintain split lists for standard/custom just in case
                this.Layouts = [];
                this.StandardLayouts = [];
                this.CustomLayouts = [];
                // May want to migrate these to customisable locations
                this._customLayoutMap = [];
                // Activation/deactivation management
                this._activeLayoutName = Navigation.HOME_VIEW_NAME;
                this._activeContext = null; // ActivationContext currently being processed by activation loop
                this._activationQueue = []; // Queue of ActivationContexts to be processed after the current one
                this._activationLog = []; // Log of processed contexts for debugging purposes
                this._activationLogSize = 0; // Size of activation log, 0 in production
                // Callback for layout map loader
                this._customLayoutMapLoaded = (layoutMap) => {
                    this._log.info("DetailNavigationHandler._customLayoutMapLoaded()");
                    this._customLayoutMap = layoutMap;
                };
                this._widgetsReadyCallback = () => {
                    this._log.info("DetailNavigationHandler._widgetsReadyCallback()");
                    this._core.Widgets.Cache.flushCache();
                };
                // Main call
                this.requestActivation = (context) => {
                    this._log.info("DetailNavigationHandler.requestActivation()");
                    this._activationQueue.push(context);
                    if (!this._activeContext)
                        window.setTimeout(this._processActivationQueueItem, 0);
                };
                // Debug call
                this.debugActivation = (aType, layout = '[[CURRENT]]', id = 0, primary = null, widget = null) => {
                    let at = (aType) ? aType : Navigation.LayoutActivationType.OTHER;
                    let context = new WPTNamespace.Navigation.ActivationContext(widget, at);
                    context.Layout = (layout && (layout != '[[CURRENT]]')) ? layout : this._core.Navigation.Details.getActiveLayoutName();
                    context.ActivationID = (id != null) ? id : 0;
                    context.PrimaryContext = primary;
                    this._core.Navigation.Details.requestActivation(context);
                };
                this._processActivationQueueItem = () => {
                    this._log.info("DetailNavigationHandler._processActivationQueueItem()");
                    if (this._activationQueue.length == 0)
                        return;
                    // Need a valid context, and we might run out
                    let contextValid = false;
                    this._log.trace("_processActivationQueueItem searching for valid contexts");
                    while (!contextValid && (this._activationQueue.length > 0)) {
                        // Grab the next available context
                        this._activeContext = this._activationQueue.shift();
                        // If we are logging, want even invalid contexts
                        if (this._activationLogSize > 0) {
                            this._activationLog.unshift(this._activeContext);
                            while (this._activationLog.length > this._activationLogSize)
                                this._activationLog.pop();
                        }
                        // Discard requests coming from widgets not on the current layout
                        if (this._activeContext.ActivatingWidget && (this._activeContext.ActivatingWidget.CurrentLayout != this._activeLayoutName))
                            contextValid = false;
                        else
                            contextValid = true;
                    }
                    // If we get here without a valid context we are done
                    if (!contextValid) {
                        this._log.trace("_processActivationQueueItem found no valid contexts");
                        this._activeContext = null;
                        return;
                    }
                    // Give the context object a view of the activation - WAIT until it's got any document info needed
                    try {
                        this._log.trace("_processActivationQueueItem forwarding request to Context object");
                        this._core.Context.processActivation(this._activeContext, this._activateLayoutFinalise);
                    }
                    catch (err) {
                        // Try to recover from uncaught exceptions here - this might be a terrible idea, maybe need a global error handler on window.error?
                        console.error(`Activation loop caught error '${err.name}': ${err.message}'`);
                        if ((this._activeContext != null) && (this._activeContext.FinalCallbacks != null) && (this._activeContext.FinalCallbacks.length > 0)) {
                            this._log.trace("Finalisation included callbacks on context - firing.");
                            this._activeContext.FinalCallbacks.forEach(callback => { callback(this._activeContext); });
                        }
                        this._activeContext = null;
                        window.setTimeout(this._processActivationQueueItem, 0);
                    }
                };
                // Called back after the update of the application context object 
                this._activateLayoutFinalise = () => {
                    this._log.info("DetailNavigationHandler._activateLayoutFinalise()");
                    if (this._log.isTraceEnabled() && this._activeContext) {
                        this._log.trace(`Finalising against ${this._activeContext.ActivationType} into slots ${this._activeContext.Slots}`);
                    }
                    // Request for "Home" may be a return from external OR a call from [[CURRENT]] with actual context
                    if (this._activeContext.Layout == Navigation.HOME_VIEW_NAME) {
                        if (this._activeLayoutName != Navigation.HOME_VIEW_NAME) {
                            this._log.trace("Returning to home view from detail view.");
                            // Return to home from elsewhere
                            this.deactivateLayout();
                            this._activeLayoutName = Navigation.HOME_VIEW_NAME;
                            this._core.Widgets.Cache.flushCache();
                            this._core.Functions.showElement(this._nav.Home.HomeView);
                            this._core.Widgets.returnedToHomepage();
                            // NB: This BYPASSES the event loop/activation queue!
                            let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.RETURNED_TO_HOME_VIEW);
                            navEvent.ActivationID = 0;
                            this._core.Widgets.StandardInstances.forEach(instance => { instance.activate(navEvent); });
                            this._core.Widgets.CustomInstances.forEach(instance => { instance.activate(navEvent); });
                        }
                        else if (this._activeContext.ActivationType != Navigation.LayoutActivationType.NONE) {
                            // Already home, so forward context to all widgets
                            this._log.trace("Activating all widgets on home view with passed context.");
                            this._core.Widgets.StandardInstances.forEach(instance => { instance.activate(this._activeContext); });
                            this._core.Widgets.CustomInstances.forEach(instance => { instance.activate(this._activeContext); });
                        }
                        // Work done, clear the context and restart event loop processing
                        this._log.trace("Finalising call loops, restarting event loop.");
                        if ((this._activeContext != null) && (this._activeContext.FinalCallbacks != null) && (this._activeContext.FinalCallbacks.length > 0)) {
                            this._log.trace("Finalisation included callbacks on context - firing.");
                            this._activeContext.FinalCallbacks.forEach(callback => { callback(this._activeContext); });
                        }
                        this._activeContext = null;
                        window.setTimeout(this._processActivationQueueItem, 0);
                        return;
                    }
                    this._activeContext.TargetDIV = this.DetailView;
                    if ((this._activeContext.Layout === this._activeLayoutName) && !this._activeContext.ForceReload) {
                        this._log.trace("firing secondaryActivation");
                        this.Layouts[this._activeLayoutName].secondaryActivation(this._activeContext);
                        // Work done, clear the context and restart event loop processing
                        this._log.trace("Finalising call loops, restarting event loop.");
                        if ((this._activeContext != null) && (this._activeContext.FinalCallbacks != null) && (this._activeContext.FinalCallbacks.length > 0)) {
                            this._log.trace("Finalisation included callbacks on context - firing.");
                            this._activeContext.FinalCallbacks.forEach(callback => { callback(this._activeContext); });
                        }
                        this._activeContext = null;
                        window.setTimeout(this._processActivationQueueItem, 0);
                        return;
                    }
                    // If we get here we are activating a new layout...
                    // Pull any passed widgets into the cache, activating and extended transfer list. Transfer list includes activator.
                    if (this._activeContext.hasOwnProperty("TransferWidgets") && (this._activeContext.TransferWidgets != null)) {
                        this._activeContext.TransferWidgets.forEach(request => {
                            this._core.Widgets.Cache.cacheInstance(request.Instance);
                        });
                    }
                    // Launch if already loaded, load (with implicit activation) if not
                    if (this._activeContext.Layout in this.Layouts) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using already loaded layout");
                        }
                        this.deactivateLayout();
                        this.Layouts[this._activeContext.Layout].activate(this._activeContext, this._widgetsReadyCallback, this._dvSecondaryActivationComplete);
                        this._activeLayoutName = this._activeContext.Layout;
                    }
                    else {
                        // Layout not loaded yet - pull it in
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("loading previously unused layout");
                        }
                        // Our layout name might be tagged, so here we pull the official class identifier
                        let layoutId = this._activeContext.Layout;
                        if (this._activeContext.Layout.includes(':'))
                            layoutId = this._activeContext.Layout.split(':').shift();
                        let custom = false;
                        let layoutRecord = STANDARD_LAYOUTS.find(record => record.Name === layoutId);
                        if (!layoutRecord) {
                            layoutRecord = this._customLayoutMap.find(record => record.Name === layoutId);
                            custom = true;
                        }
                        if (layoutRecord) {
                            this.deactivateLayout();
                            // _loadLayout includes an explicit activation
                            if (custom)
                                this._loadCustomLayout(this._activeContext.Layout, layoutRecord);
                            else
                                this._createLayoutInstance(this._activeContext.Layout, layoutRecord, custom);
                            this._activeLayoutName = this._activeContext.Layout;
                        }
                        else {
                            throw Error(`Request for unknown detail layout '${this._activeContext.Layout}'`);
                        }
                    }
                };
                this.deactivateLayout = () => {
                    this._log.info("DetailNavigationHandler.deactivateLayout()");
                    if ((this._activeLayoutName != null) && (this._activeLayoutName != Navigation.HOME_VIEW_NAME)) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Detail view handler deactivating layout '${this._activeLayoutName}'`);
                        }
                        this.Layouts[this._activeLayoutName].deactivate();
                        this._core.Functions.hideElement(this.DetailView);
                        this._activeLayoutName = null;
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("Detail view handler deactivating home layout");
                        }
                        this._core.Functions.hideElement(this._nav.Home.HomeView);
                    }
                };
                this.resetNavigation = () => {
                    this._log.info("DetailNavigationHandler.resetNavigation()");
                    this.deactivateLayout();
                    this._activeLayoutName = Navigation.HOME_VIEW_NAME;
                    this.Layouts = [];
                    this.StandardLayouts = [];
                    this.CustomLayouts = [];
                    // Make sure any dynamic storage is definitely cleared
                    this._core.Widgets.Cache.flushCache(false);
                    this._core.Widgets.Cache.emptyFreezer();
                    this.DetailView.innerHTML = "";
                };
                this._loadCustomLayout = (layoutName, layoutRecord) => {
                    this._log.info("DetailNavigationHandler._loadCustomLayout()");
                    let mainConfig = this._core.Config.getMainConfig();
                    this._core.Loader.loadUnversionedJS(`${mainConfig.Resources.CustomDetailFiles}/detail${layoutName}.js`, this._createLayoutInstance.bind(this, layoutName, layoutRecord, true), this._customJSLoadError);
                };
                this._customJSLoadError = (url, statusText) => {
                    this._log.info("DetailNavigationHandler._customJSLoadError()");
                    throw new Error(`Error encountered loading resources ${url}:\n${statusText}`);
                };
                this._createLayoutInstance = (layoutName, layoutRecord, custom) => {
                    this._log.info("DetailNavigationHandler._createLayoutInstance()");
                    try {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Attempting to load layout type '${layoutRecord.Name}' as '${layoutName}'`);
                        }
                        // Load our stuff
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Locating constructor ${layoutRecord.Class}`);
                        }
                        let layoutConstructor = this._core.Functions.stringToFunction(layoutRecord.Class);
                        let layoutInstance = new layoutConstructor(layoutName, this._core, this, custom, this._activeContext, this._widgetsReadyCallback, this._dvSecondaryActivationComplete);
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Created from ${layoutInstance.constructor.name}`);
                        }
                        // Apparently adding by index and by push() allows us to both iterate and call by key without having double instances
                        this.Layouts[layoutName] = layoutInstance;
                        this.Layouts.push(layoutInstance);
                        if (custom) {
                            this.CustomLayouts[layoutName] = layoutInstance;
                            this.CustomLayouts.push(layoutInstance);
                        }
                        else {
                            this.StandardLayouts[layoutName] = layoutInstance;
                            this.StandardLayouts.push(layoutInstance);
                        }
                    }
                    catch (ex) {
                        console.error(`Unable to load detail layout class for view '${layoutName}': ${ex.message}`);
                    }
                };
                this.getActiveLayout = () => {
                    this._log.info("DetailNavigationHandler.getActiveLayout()");
                    if (this._activeLayoutName) {
                        return this.Layouts[this._activeLayoutName];
                    }
                    else {
                        return null;
                    }
                };
                this.getActiveLayoutName = () => {
                    this._log.info("DetailNavigationHandler.getActiveLayoutName()");
                    if (this._activeLayoutName) {
                        return this._activeLayoutName;
                    }
                    else {
                        return Navigation.HOME_VIEW_NAME;
                    }
                };
                this._dvSecondaryActivationComplete = () => {
                    this._log.info("DetailNavigationHandler._dvSecondaryActivationComplete()");
                    // Maybe fire callback if it's set
                    if ((this._activeContext != null) && (this._activeContext.FinalCallbacks != null) && (this._activeContext.FinalCallbacks.length > 0)) {
                        this._log.trace("Finalisation included callbacks on context - firing.");
                        this._activeContext.FinalCallbacks.forEach(callback => { callback(this._activeContext); });
                    }
                    // Get the event loop going again
                    this._activeContext = null;
                    window.setTimeout(this._processActivationQueueItem, 0);
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DetailNavigationHandler::constructor");
                this._nav = navigation;
                this._activeLayoutName = Navigation.HOME_VIEW_NAME;
                this.DetailView = navigation.MainPage.querySelector("#DetailView");
                if (this.DetailView == null) {
                    throw Error("DIV element '#DetailView' not defined in main layout HTML");
                }
                // Layouts are loaded on demand, but we grab the map right away so we know what to expect
                let appConfig = this._core.Config.getApplicationConfig();
                if (appConfig.hasOwnProperty("Custom") && appConfig.Custom.hasOwnProperty("UseCustomLayouts") && appConfig.Custom.UseCustomLayouts) {
                    this._core.Loader.getUnversionedJSON(`${this._core.Config.getMainConfig().Resources.CustomDetailFiles}/customLayouts.json`, this._customLayoutMapLoaded, function () { });
                }
                if (appConfig.hasOwnProperty("ActivationLog") && (appConfig.ActivationLog != null))
                    this._activationLogSize = appConfig.ActivationLog;
                // If we are restarting navigation, want a clear widget cache
                this._core.Widgets.Cache.flushCache(false);
                if (this._log.isTraceEnabled()) {
                    this._log.trace("DetailNavigationHandler::constructor completed");
                }
            }
        }
        Navigation.DetailNavigationHandler = DetailNavigationHandler;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
